<template>
    <div v-dompurify-html="changeImgHtml"></div>
</template>

<script>
export default {
    props: {
        htmlSnip: String
    },
    computed: {
        /**
         * 存储的富文本图片标签加上图片预览功能
         *
         * @return {string} 处理后的文本字符串
         */
        changeImgHtml: function() {
            // 图片标签头部
            const imgReg = /<img class="upload-img"/g;
            return this.htmlSnip.replace(imgReg, '<img preview="0" class="upload-img"');
        }
    }
};
</script>
